{
  "name": "pkg-exe-build",
  "version": "2.0.0",
  "description": "Configure Windows PKG package generated exe file icon and detailed information\nwindows 平台下 配置图标及详细信息 使用 pkg 打包 生成 exe 文件",
  "main": "dist/index.js",
  "type": "module",
  "bin": {
    "pkge": "./dist/cli.js"
  },
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "files": [
    "dist/**/*",
    "src/**/*",
    "LICENSE",
    "package.json",
    "README_ZH.md",
    "README.md"
  ],
  "scripts": {
    "clean": "rimraf dist",
    "build": "npm run clean && tsup",
    "test": "node ./test/build.cjs",
    "test:cli": "node ./test/cli.mjs"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/PromiseAll/pkg-exe-build.git"
  },
  "keywords": [
    "pkg",
    "exe",
    "build",
    "windows",
    "setup",
    "pack",
    "packager",
    "binary"
  ],
  "author": "PromiseAll",
  "license": "LGPL-3.0-or-later",
  "bugs": {
    "url": "https://github.com/PromiseAll/pkg-exe-build/issues"
  },
  "homepage": "https://github.com/PromiseAll/pkg-exe-build#readme",
  "devDependencies": {
    "@types/node": "^24.2.1",
    "resedit": "^2.0.3",
    "rimraf": "^6.0.1",
    "tsup": "^8.5.0",
    "typescript": "^5.9.2"
  },
  "dependencies": {
    "@yao-pkg/pkg": "^6.6.0",
    "commander": "^14.0.0"
  }
}